import React from 'react';

/**
 * Modal with tips for getting the best results from Jesse.
 * Redesigned with visual cards, emoji accents, and scannable layout.
 */
const TipsModal = ({ isVisible, onClose }) => {
  if (!isVisible) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content tips-modal" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <span className="material-icons">close</span>
        </button>

        <div className="modal-icon-header success">
          <span className="material-icons">lightbulb</span>
        </div>

        <h2>Tips voor goede input</h2>
        <p className="modal-subtitle">Zo haal je het beste uit Jesse</p>

        {/* Tip cards grid */}
        <div className="tip-cards">

          <div className="tip-card tip-card--copy">
            <div className="tip-card__header">
              <span className="tip-card__emoji">📋</span>
              <h3>Kopiëren & delen</h3>
            </div>
            <div className="tip-card__items">
              <div className="tip-item">
                <span className="tip-item__icon material-icons">touch_app</span>
                <span><strong>Klik op een bericht</strong> van Jesse — er verschijnt een kopieerknop</span>
              </div>
              <div className="tip-item">
                <span className="tip-item__icon material-icons">select_all</span>
                <span><strong>Hele vacature?</strong> Gebruik "Kopieer hele tekst" of het review scherm</span>
              </div>
              <div className="tip-item">
                <span className="tip-item__icon material-icons">email</span>
                <span><strong>Direct versturen</strong> via email of downloaden als PDF</span>
              </div>
            </div>
          </div>

          <div className="tip-card tip-card--prep">
            <div className="tip-card__header">
              <span className="tip-card__emoji">🎯</span>
              <h3>Voorbereiding</h3>
            </div>
            <div className="tip-card__items">
              <div className="tip-item">
                <span className="tip-item__icon material-icons">work</span>
                <span>Weet wat iemands <strong>werkzaamheden</strong> worden</span>
              </div>
              <div className="tip-item">
                <span className="tip-item__icon material-icons">payments</span>
                <span>Ken jullie <strong>aanbod</strong> — salaris + voorwaarden</span>
              </div>
              <div className="tip-item">
                <span className="tip-item__icon material-icons">emoji_people</span>
                <span>Bedenk <strong>waarom</strong> iemand bij jullie moet werken</span>
              </div>
            </div>
          </div>

          <div className="tip-card tip-card--chat">
            <div className="tip-card__header">
              <span className="tip-card__emoji">💬</span>
              <h3>Tijdens het gesprek</h3>
            </div>
            <div className="tip-card__items">
              <div className="tip-item">
                <span className="tip-item__icon material-icons">record_voice_over</span>
                <span>Spreek <strong>natuurlijk</strong> — alsof je met een collega praat</span>
              </div>
              <div className="tip-item">
                <span className="tip-item__icon material-icons">lightbulb</span>
                <span>Geef <strong>concrete voorbeelden</strong> bij abstracte begrippen</span>
              </div>
              <div className="tip-item">
                <span className="tip-item__icon material-icons">volume_off</span>
                <span>Zorg voor <strong>weinig achtergrondgeluid</strong></span>
              </div>
              <div className="tip-item">
                <span className="tip-item__icon material-icons">pause</span>
                <span>Laat Jesse <strong>uitpraten</strong> voor je antwoordt</span>
              </div>
            </div>
          </div>

          <div className="tip-card tip-card--best">
            <div className="tip-card__header">
              <span className="tip-card__emoji">✨</span>
              <h3>Jesse's gouden tips</h3>
            </div>
            <div className="tip-card__items">
              <div className="tip-item tip-item--highlight">
                <span className="tip-item__icon material-icons">format_quote</span>
                <span>"Reparatie van fietsen" werkt beter dan "diverse werkzaamheden"</span>
              </div>
              <div className="tip-item tip-item--highlight">
                <span className="tip-item__icon material-icons">trending_down</span>
                <span>Minder eisen = meer kandidaten. Moet het echt 5 jaar ervaring zijn?</span>
              </div>
              <div className="tip-item tip-item--highlight">
                <span className="tip-item__icon material-icons">upload_file</span>
                <span>Al een tekst? <strong>Upload hem</strong> voor snellere verbetering!</span>
              </div>
            </div>
          </div>
        </div>

        <button className="modal-button primary" onClick={onClose}>
          <span className="material-icons">rocket_launch</span>
          Begrepen, laten we beginnen!
        </button>
      </div>
    </div>
  );
};

export default TipsModal;
